import React from 'react';
import { Box, Stack } from '@mui/material';
import { AccessTimeOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components';
import {
  DueDateEdit,
  CreatedDateEdit,
  UpdatedDateEdit,
  ClosedDateEdit
} from '../fields';

/**
 * TimeTrackingSection - Manages all date and time related fields
 * Includes due date, created date, and updated date
 */
export const TimeTrackingSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader 
        icon={<AccessTimeOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />} 
        title="Time Tracking" 
      />
      <SectionPaper>
        <Stack direction="row" gap={2}>
          <DueDateEdit />
          <CreatedDateEdit />
          <UpdatedDateEdit />
          <ClosedDateEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default TimeTrackingSection;
